import FilebrowserDialog	from "./dialog-filebrowser.js";

class MyFilebrowserDialog extends FilebrowserDialog {
	static constructor() {
		customElements.define("fulljs-myfilebrowserdialog", MyFilebrowserDialog);
	}
	constructor() {
		super();
		
		this.show();
	}
	onchange(event) {
		server.rcall("RM_project_open", this.url).then(function(result) {
			
			window.dispatchEvent( new CustomEvent("onprojectopen", {
				detail: result
			}) );
			
			this.close();
		}.bind(this)).catch(function(result) {
			this.close();
			alert(result);
		}.bind(this));
	}
}

MyFilebrowserDialog.constructor();

export default MyFilebrowserDialog;